import React from "react";
import { Redirect } from "react-router-dom";

// Pages Component
import Chat from "../pages/Chat/Chat";

// Pages File Manager
import FileManager from "../pages/FileManager/index";

// Pages Calendar
import Calendar from "../pages/Calendar/index";

//Tasks
import TasksList from "../pages/Tasks/tasks-list";
import TasksKanban from "../pages/Tasks/tasks-kanban";
import TasksCreate from "../pages/Tasks/tasks-create";

//Projects
import ProjectsGrid from "../pages/Projects/projects-grid";
import ProjectsList from "../pages/Projects/projects-list";
import ProjectsOverview from "../pages/Projects/ProjectOverview/projects-overview";
import ProjectsCreate from "../pages/Projects/projects-create";

//Ecommerce Pages
import EcommerceProducts from "../pages/Ecommerce/EcommerceProducts/index";
import EcommerceProductDetail from "../pages/Ecommerce/EcommerceProducts/EcommerceProductDetail";
import EcommerceOrders from "../pages/Ecommerce/EcommerceOrders/index";
import EcommerceCustomers from "../pages/Ecommerce/EcommerceCustomers/index";
import EcommerceCart from "../pages/Ecommerce/EcommerceCart";
import EcommerceCheckout from "../pages/Ecommerce/EcommerceCheckout";
import EcommerceShops from "../pages/Ecommerce/EcommerceShops/index";
import EcommerceAddProduct from "../pages/Ecommerce/EcommerceAddProduct";

//Email
import EmailInbox from "../pages/Email/email-inbox";
import EmailRead from "../pages/Email/email-read";
import EmailBasicTemplte from "../pages/Email/email-basic-templte";
import EmailAlertTemplte from "../pages/Email/email-template-alert";
import EmailTemplateBilling from "../pages/Email/email-template-billing";

//Invoices
import InvoicesList from "../pages/Invoices/invoices-list";
import InvoiceDetail from "../pages/Invoices/invoices-detail";

// Authentication related pages
import Login from "../pages/Authentication/Login";
import Logout from "../pages/Authentication/Logout";
import Register from "../pages/Authentication/Register";
import ForgetPwd from "../pages/Authentication/ForgetPassword";

// Inner Authentication
import Login1 from "../pages/AuthenticationInner/Login";
import Login2 from "../pages/AuthenticationInner/Login2";
import Register1 from "../pages/AuthenticationInner/Register";
import Register2 from "../pages/AuthenticationInner/Register2";
import Recoverpw from "../pages/AuthenticationInner/Recoverpw";
import Recoverpw2 from "../pages/AuthenticationInner/Recoverpw2";
import ForgetPwd1 from "../pages/AuthenticationInner/ForgetPassword";
import ForgetPwd2 from "../pages/AuthenticationInner/ForgetPwd2";
import LockScreen from "../pages/AuthenticationInner/auth-lock-screen";
import LockScreen2 from "../pages/AuthenticationInner/auth-lock-screen-2";
import ConfirmMail from "../pages/AuthenticationInner/page-confirm-mail";
import ConfirmMail2 from "../pages/AuthenticationInner/page-confirm-mail-2";
import EmailVerification from "../pages/AuthenticationInner/auth-email-verification";
import EmailVerification2 from "../pages/AuthenticationInner/auth-email-verification-2";
import TwostepVerification from "../pages/AuthenticationInner/auth-two-step-verification";
import TwostepVerification2 from "../pages/AuthenticationInner/auth-two-step-verification-2";

// Dashboard
import Dashboard from "../pages/Dashboard/index";
import DashboardSaas from "../pages/Dashboard-saas/index";
import DashboardCrypto from "../pages/Dashboard-crypto/index";
import DashboardBlog from "../pages/Dashboard-blog/index";

//Party
// import addParty from "../pages/Party-add/index";

//Crypto
import CryptoWallet from "../pages/Crypto/CryptoWallet/crypto-wallet";
import CryptoBuySell from "../pages/Crypto/crypto-buy-sell";
import CryptoExchange from "../pages/Crypto/crypto-exchange";
import CryptoLending from "../pages/Crypto/crypto-lending";
import CryptoOrders from "../pages/Crypto/CryptoOrders/crypto-orders";
import CryptoKYCApplication from "../pages/Crypto/crypto-kyc-application";
import CryptoIcoLanding from "../pages/Crypto/CryptoIcoLanding/index";

// Charts
import ChartApex from "../pages/Charts/Apexcharts";
import ChartistChart from "../pages/Charts/ChartistChart";
import ChartjsChart from "../pages/Charts/ChartjsChart";
import EChart from "../pages/Charts/EChart";
import SparklineChart from "../pages/Charts/SparklineChart";
import ChartsKnob from "../pages/Charts/charts-knob";
import ReCharts from "../pages/Charts/ReCharts";

// Maps
import MapsGoogle from "../pages/Maps/MapsGoogle";
import MapsVector from "../pages/Maps/MapsVector";
import MapsLeaflet from "../pages/Maps/MapsLeaflet";

//Icons
import IconBoxicons from "../pages/Icons/IconBoxicons";
import IconDripicons from "../pages/Icons/IconDripicons";
import IconMaterialdesign from "../pages/Icons/IconMaterialdesign";
import IconFontawesome from "../pages/Icons/IconFontawesome";

//Tables
import BasicTables from "../pages/Tables/BasicTables";
import DatatableTables from "../pages/Tables/DatatableTables";
import ResponsiveTables from "../pages/Tables/ResponsiveTables";
import EditableTables from "../pages/Tables/EditableTables";
import DragDropTables from "../pages/Tables/DragDropTables";

// Forms
import FormElements from "../pages/Forms/FormElements/index";
import FormLayouts from "../pages/Forms/FormLayouts";
import FormAdvanced from "../pages/Forms/FormAdvanced";
import FormEditors from "../pages/Forms/FormEditors";
import FormValidations from "../pages/Forms/FormValidations";
import FormMask from "../pages/Forms/FormMask";
import FormRepeater from "../pages/Forms/FormRepeater";
import FormUpload from "../pages/Forms/FormUpload";
import FormWizard from "../pages/Forms/FormWizard";
import FormXeditable from "../pages/Forms/FormXeditable";
import DualListbox from "../pages/Forms/DualListbox";

//Ui
import UiAlert from "../pages/Ui/UiAlert";
import UiButtons from "../pages/Ui/UiButtons";
import UiCards from "../pages/Ui/UiCards";
import UiCarousel from "../pages/Ui/UiCarousel";
import UiColors from "../pages/Ui/UiColors";
import UiDropdown from "../pages/Ui/UiDropdown";
import UiGeneral from "../pages/Ui/UiGeneral";
import UiGrid from "../pages/Ui/UiGrid";
import UiImages from "../pages/Ui/UiImages";
import UiLightbox from "../pages/Ui/UiLightbox";
import UiModal from "../pages/Ui/UiModal";
import UiProgressbar from "../pages/Ui/UiProgressbar";
import UiTabsAccordions from "../pages/Ui/UiTabsAccordions";
import UiTypography from "../pages/Ui/UiTypography";
import UiVideo from "../pages/Ui/UiVideo";
import UiSessionTimeout from "../pages/Ui/UiSessionTimeout";
import UiRating from "../pages/Ui/UiRating";
import UiRangeSlider from "../pages/Ui/UiRangeSlider";
import UiNotifications from "../pages/Ui/ui-notifications";
import UiToast from "../pages/Ui/UiToast";
import UiOffCanvas from "../pages/Ui/UiOffCanvas";
import Breadcrumb from "../pages/Ui/UiBreadcrumb";
import UiPlaceholders from "../pages/Ui/UiPlaceholders";

//Pages
import PagesStarter from "../pages/Utility/pages-starter";
import PagesMaintenance from "../pages/Utility/pages-maintenance";
import PagesComingsoon from "../pages/Utility/pages-comingsoon";
import PagesTimeline from "../pages/Utility/pages-timeline";
import PagesFaqs from "../pages/Utility/pages-faqs";
import PagesPricing from "../pages/Utility/pages-pricing";
import Pages404 from "../pages/Utility/pages-404";
import Pages500 from "../pages/Utility/pages-500";

//Contacts
import ContactsGrid from "../pages/Contacts/contacts-grid";
import ContactsList from "../pages/Contacts/ContactList/contacts-list";
import ContactsProfile from "../pages/Contacts/ContactsProfile/contacts-profile";

//Blog
import BlogList from "../pages/Blog/BlogList/index";
import BlogGrid from "../pages/Blog/BlogGrid/index";
import BlogDetails from "../pages/Blog/BlogDetails";

//  manage party
import NewPassword from "pages/AuthenticationInner/NewPassword";
import AddParty from "components/ManageParty/AddParty";
import PartyList from "components/ManageParty/PartyList";
// import EditPartyDetail from "components/ManageParty/EditPartyDetail";
import ViewPartyDetail from "components/ManageParty/ViewPartyDetail";

// User profile
import UserProfile from "../pages/Authentication/Profile";
import UserPassword from "pages/Authentication/UserPassword";
import AddUnit from "components/manageOrganization/AddUnit";
import OrganizationCompanyList from "components/manageOrganization/OrganizationCompanyList";
import OrganizationDetail from "components/manageOrganization/OrganizationDetail";
import ViewInternalUnit from "components/manageOrganization/ViewInternalUnit";
import viewExternalUnit from "components/manageOrganization/viewExternalUnit";
import GstRate from "components/manageOrganization/GstRate";
import AddMaterialItem from "components/manageOrganization/AddMaterialItem";
import AddPurchasedItem from "components/manageOrganization/AddPurchasedItem";
import CompanyMaterialStock from "components/manageOrganization/CompanyMaterialStock";
import AllocateMaterial from "components/manageOrganization/AllocateMaterial";
import AddUser from "components/ManageUser/AddUser";
import UserList from "components/ManageUser/UserList";
import ViewUserDetail from "components/ManageUser/ViewUserDetail";
import InternalUnitinward from "components/ManageStock/Inwardstock/InternalUnitinward";
// import ExternalUnitinward from "components/ManageStock/Inwardstock/ExternalUnitinward";
import InternalUnitoutward from "components/ManageStock/Outwardstock/InternalUnitoutward";
import ExternalUnitoutward from "components/ManageStock/Outwardstock/ExternalUnitoutward";
import OfficeStockList from "components/ManageStock/OfficeStockList";
import EditStockInword from "components/ManageStock/EditStockInword";
import ViewStockInword from "components/ManageStock/ViewStockInword";
import OutwordStockList from "components/ManageStock/OutwordStockList";
import EditStockOutword from "components/ManageStock/EditStockOutword";
import ViewStockOutword from "components/ManageStock/ViewStockOutword";
import DeliveryChallan from "components/ManageStock/DeliveryChallan";
import UserDashboard from "components/sales-office/UserDashboard";
import UserEditInwardStock from "components/sales-office/UserEditInwardStock";
import UserViewInwardStock from "components/sales-office/UserViewInwardStock";
import UserEditOutwardStock from "components/sales-office/UserEditOutwardStock";
import UserViewOutwardStock from "components/sales-office/UserViewOutwardStock";
import UserAddStockInward from "components/sales-office/UserAddStockInward";
import UserOutwardStock from "components/sales-office/UserOutwardStock";
import UserOfficeStockList from "components/sales-office/UserOfficeStockList";
import UserOutwardStockList from "components/sales-office/UserOutwardStockList";
import SalesUserProfile from "components/sales-office/SalesUserProfile";
import UserUpdatePassword from "components/sales-office/UserUpdatePassword";
import DataEntryDashboard from "components/factory-office/DataEntryDashboard";
import DataEntryAddStockInward from "components/factory-office/DataEntryAddStockInward";
import DataEntryOutwardStock from "components/factory-office/DataEntryOutwardStock";
import DataEntryOfficeStockList from "components/factory-office/DataEntryOfficeStockList";
import DataEntryEditStockInward from "components/factory-office/DataEntryEditStockInward";
import DataEntryViewStockInward from "components/factory-office/DataEntryViewStockInward";
import DataEntryOutwardStockList from "components/factory-office/DataEntryOutwardStockList";
import DataEntryEditOutwardStock from "components/factory-office/DataEntryEditOutwardStock";
import DataEntryViewOutwardStok from "components/factory-office/DataEntryViewOutwardStok";
import DataEntryUserProfile from "components/factory-office/DataEntryUserProfile";
import GraderDashboard from "components/graderFlow/GraderDashboard";
import EditverifyAndAccept from "components/graderFlow/EditverifyAndAccept";
import GraderStockList from "components/graderFlow/GraderStockList";
import ViewVerifyAndAccept from "components/graderFlow/ViewVerifyAndAccept";
import GraderAssignScreen from "components/graderFlow/GraderAssignScreen";
import GraderProfile from "components/graderFlow/GraderProfile";
import GraderUpdatePassword from "components/graderFlow/GraderUpdatePassword";
import GraderProcessedStock from "components/graderFlow/GraderProcessedStock";
import Cycle1VerifyAndAccept from "components/graderFlow/Cycle1VerifyAndAccept";
import GraderReassign from "components/graderFlow/GraderReassign";
import ProcessStockAccepted from "components/graderFlow/ProcessStockAccepted";
import ClientRejectStock from "components/graderFlow/ClientRejectStock";
import FillerDashboard from "components/fillerFlow/FillerDashboard";
import FillerEditVerifyAndAccept from "components/fillerFlow/FillerEditVerifyAndAccept";
import FillerViewVerifyAndAccept from "components/fillerFlow/FillerViewVerifyAndAccept";
import FillerStockList from "components/fillerFlow/FillerStockList";
import FillerAssignCube from "components/fillerFlow/FillerAssignCube";
import FillerAssignCubeDetail from "components/fillerFlow/FillerAssignCubeDetail";
import EditFillingProcess from "components/fillerFlow/EditFillingProcess";
import FillerUpdatePassword from "components/fillerFlow/FillerUpdatePassword";
import FillerProfle from "components/fillerFlow/FillerProfle";
import MachineOperatorDashboard from "components/machine-operator/MachineOperatorDashboard";
import MacOperatorEditVerifyAndAccept from "components/machine-operator/MacOperatorEditVerifyAndAccept";
import MacOperatorCubeList from "components/machine-operator/MacOperatorCubeList";
import MacOperatorViewVerifyAndAccept from "components/machine-operator/MacOperatorViewVerifyAndAccept";
import MacOperatorAssignCube from "components/machine-operator/MacOperatorAssignCube";
import MacOperatorUserProfile from "components/machine-operator/MacOperatorUserProfile";
import MacOperatorUpdatePassword from "components/machine-operator/MacOperatorUpdatePassword";
import PartyWiseReports from "components/admin-reports/PartyWiseReports";
import PartyWiseJangad from "components/admin-reports/PartyWiseJangad";
import GenerateLedger from "components/admin-reports/GenerateLedger";
import LedgerReports from "components/admin-reports/LedgerReports";
import PrintLedgerReport from "components/admin-reports/PrintLedgerReport";
import ViewledgerReport from "components/admin-reports/ViewledgerReport";
import LedgerPrint from "components/admin-reports/LedgerPrint";
import ActivePersonStock from "components/admin-reports/ActivePersonStock";
import PartyWiseStockReport from "components/admin-reports/PartyWiseStockReport";
import ExternalGenerateLedger from "components/External-adminReport/ExternalGenerateLedger";
import ExternalLedgerReport from "components/External-adminReport/ExternalLedgerReport";
import ExternalPrintLedgerReport from "components/External-adminReport/ExternalPrintLedgerReport";
import ExternalViewLedgerReport from "components/External-adminReport/ExternalViewLedgerReport";
import ExternalLedgerPrint from "components/External-adminReport/ExternalLedgerPrint";
import TransactionList from "components/transaction-history/TransactionList";
import EditTransactionDetail from "components/transaction-history/EditTransactionDetail";
import ViewTransactionHistory from "components/transaction-history/ViewTransactionHistory";
import TaxInvoice from "components/transaction-history/TaxInvoice";
import PaymentCash from "components/transaction-history/PaymentCash";
import PaymentCheque from "components/transaction-history/PaymentCheque";
import PaymentRTGS from "components/transaction-history/PaymentRTGS";
import AssignStockList from "components/graderFlow/AssignStockList";
import FillerProcessList from "components/fillerFlow/FillerProcessList";
import AssignCubeStockList from "components/machine-operator/AssignCubeStockList";
import DataEntryAddStockOutward from "components/factory-office/DataEntryAddStockOutward";
import Shape from "components/manageOrganization/Shape";
import Items from "components/manageOrganization/Items";
import Category from "components/manageOrganization/Category";
import Inclusion from "components/manageOrganization/Inclusion";
import GraderAssignScreen2 from "components/graderFlow/GraderAssignScreen2";
import CubeList from "components/fillerFlow/CubeList";
import ProcessStockAcceptAndReject from "components/graderFlow/ProcessStockAcceptAndReject";
import GraderCompleteStockList from "components/graderFlow/GraderCompleteStockList";
import GraderDataEntryAssign from "components/graderFlow/GraderDataEntryAssign";
import GraderRepeatStockList from "components/graderFlow/GraderRepeatStockList";
import FillerRepeatStock from "components/fillerFlow/FillerRepeatStock";
import AddBank from "components/transaction-history/AddBank";
import AllocateMaterialList from "components/manageOrganization/AllocateMaterialList";
import ViewJangadTImeline from "components/graderFlow/ViewJangadTImeline";
import RecieveExternalJangad from "components/sales-office/RecieveExternalJangad";
import Default404 from "pages/Default404";
import LedgerApproveStatusUpdate from "components/transaction-history/LedgerApproveStatusUpdate";
import ViewJangadTimelineManageStock from "components/ManageStock/ViewJangadTimelineManageStock";
import ReassignInwardJangad from "components/sales-office/ReassignInwardJangad";
import RejectedDiamond from "components/sales-office/RejectedDiamond";
import FactoryWiseReport from "components/External-adminReport/FactoryWiseReport";
import RejectedDiamondGrader from "components/factory-office/RejectedDiamondGrader";
import Processes from "components/manageOrganization/Processes";
import StockSummary from "components/machine-operator/StockSummary";
import SummaryShow from "components/machine-operator/SummaryShow";
import AddExpressInward from "components/sales-office/AddExpressInward";
import ExpressInwardList from "components/sales-office/ExpressInwardList";
import AcceptExpressInward from "components/factory-office/AcceptExpressInward";
import DataEntryExpressInwardList from "components/factory-office/DataEntryExpressInwardList";
import ExpressDashboard from "components/sales-office/ExpressDashboard";
import DataEntryExpressDashboard from "components/factory-office/DataEntryExpressDashboard";
import ViewExpressInward from "components/factory-office/ViewExpressInward";
import ExpressViewInward from "components/sales-office/ExpressViewInward";

// const authProtectedRoutes = [
//   { path: "/admin-dashboard", component: Dashboard },
//   { path: "/dashboard-saas", component: DashboardSaas },
//   { path: "/dashboard-crypto", component: DashboardCrypto },
//   { path: "/dashboard-blog", component: DashboardBlog },

//   //Crypto
//   { path: "/crypto-wallet", component: CryptoWallet },
//   { path: "/crypto-buy-sell", component: CryptoBuySell },
//   { path: "/crypto-exchange", component: CryptoExchange },
//   { path: "/crypto-lending", component: CryptoLending },
//   { path: "/crypto-orders", component: CryptoOrders },
//   { path: "/crypto-kyc-application", component: CryptoKYCApplication },

//   //profile
//   { path: "/profile", component: UserProfile },
//   {path: "/update-password", component: UserPassword},

//   //chat
//   { path: "/chat", component: Chat },

//   //File Manager
//   { path: "/apps-filemanager", component: FileManager },

//   //calendar
//   { path: "/calendar", component: Calendar },

//   //Ecommerce
//   // { path: "/ecommerce-products/:id", component: EcommerceProducts },
//   { path: "/ecommerce-products", component: EcommerceProducts },
//   { path: "/ecommerce-product-details/:id", component: EcommerceProductDetail },

//   { path: "/ecommerce-orders", component: EcommerceOrders },
//   { path: "/ecommerce-customers", component: EcommerceCustomers },
//   { path: "/ecommerce-cart", component: EcommerceCart },
//   { path: "/ecommerce-checkout", component: EcommerceCheckout },
//   { path: "/ecommerce-shops", component: EcommerceShops },
//   { path: "/ecommerce-add-product", component: EcommerceAddProduct },

//   //Email
//   { path: "/email-inbox", component: EmailInbox },
//   { path: "/email-read", component: EmailRead },
//   { path: "/email-template-basic", component: EmailBasicTemplte },
//   { path: "/email-template-alert", component: EmailAlertTemplte },
//   { path: "/email-template-billing", component: EmailTemplateBilling },

//   //Invoices
//   { path: "/invoices-list", component: InvoicesList },
//   { path: "/invoices-detail", component: InvoiceDetail },
//   { path: "/invoices-detail/:id", component: InvoiceDetail },

//   // Tasks
//   { path: "/tasks-list", component: TasksList },
//   { path: "/tasks-kanban", component: TasksKanban },
//   { path: "/tasks-create", component: TasksCreate },

//   //Projects
//   { path: "/projects-grid", component: ProjectsGrid },
//   { path: "/projects-list", component: ProjectsList },
//   { path: "/projects-overview", component: ProjectsOverview },
//   { path: "/projects-overview/:id", component: ProjectsOverview },
//   { path: "/projects-create", component: ProjectsCreate },

//   // Contacts
//   { path: "/contacts-grid", component: ContactsGrid },
//   { path: "/contacts-list", component: ContactsList },
//   { path: "/contacts-profile", component: ContactsProfile },

//   //Blog
//   { path: "/blog-list", component: BlogList },
//   { path: "/blog-grid", component: BlogGrid },
//   { path: "/blog-details", component: BlogDetails },

//   //Charts
//   { path: "/apex-charts", component: ChartApex },
//   { path: "/chartist-charts", component: ChartistChart },
//   { path: "/chartjs-charts", component: ChartjsChart },
//   { path: "/e-charts", component: EChart },
//   { path: "/sparkline-charts", component: SparklineChart },
//   { path: "/charts-knob", component: ChartsKnob },
//   { path: "/re-charts", component: ReCharts },

//   // Icons
//   { path: "/icons-boxicons", component: IconBoxicons },
//   { path: "/icons-dripicons", component: IconDripicons },
//   { path: "/icons-materialdesign", component: IconMaterialdesign },
//   { path: "/icons-fontawesome", component: IconFontawesome },

//   // Tables
//   { path: "/tables-basic", component: BasicTables },
//   { path: "/tables-datatable", component: DatatableTables },
//   { path: "/tables-responsive", component: ResponsiveTables },
//   { path: "/tables-editable", component: EditableTables },
//   { path: "/tables-dragndrop", component: DragDropTables },

//   // Maps
//   { path: "/maps-google", component: MapsGoogle },
//   { path: "/maps-vector", component: MapsVector },
//   { path: "/maps-leaflet", component: MapsLeaflet },

//   // Forms
//   { path: "/form-elements", component: FormElements },
//   { path: "/form-layouts", component: FormLayouts },
//   { path: "/form-advanced", component: FormAdvanced },
//   { path: "/form-editors", component: FormEditors },
//   { path: "/form-mask", component: FormMask },
//   { path: "/form-repeater", component: FormRepeater },
//   { path: "/form-uploads", component: FormUpload },
//   { path: "/form-wizard", component: FormWizard },
//   { path: "/form-validation", component: FormValidations },
//   { path: "/form-xeditable", component: FormXeditable },
//   { path: "/dual-listbox", component: DualListbox },

//   // manage party
//   {path: "/add-party", component: AddParty},
//   {path: "/party-list", component: PartyList},
//   {path: "/view-party-detail", component: ViewPartyDetail},

//   // manage organization
//   {path: "/organization-detail", component: OrganizationDetail},
//   {path: "/gst-rate", component: GstRate},
//   {path: "/add-unit", component: AddUnit},
//   {path: "/organization-partyList", component: OrganizationCompanyList},
//   {path: "/view-internal-unit", component: ViewInternalUnit},
//   {path: "/view-external-unit", component: viewExternalUnit},
//   {path: "/add-material-item", component: AddMaterialItem},
//   {path: "/add-purchased-item", component: AddPurchasedItem},
//   {path: "/party-material-stock", component: CompanyMaterialStock},
//   {path: "/allocate-material", component: AllocateMaterial},
//   {path: "/organization-shape", component: Shape},
//   {path: "/organization-items", component: Items},
//   {path: "/organization-category", component: Category},
//   {path: "/organization-inclusion", component: Inclusion},

//   // manage user
//   {path: "/add-user", component: AddUser},
//   {path: "/user-list", component: UserList},
//   {path: "/view-user-detail", component: ViewUserDetail},

//   // manage inward stock
//   {path: "/internal-unit-inward", component: InternalUnitinward},
//   // {path: "/external-unit-inward", component: ExternalUnitinward},

//   // manage outward stock
//   {path: "/internal-unit-outward", component: InternalUnitoutward},
//   {path: "/external-unit-outward", component: ExternalUnitoutward},

//   //manage stock
//   {path: "/office-stock-list", component: OfficeStockList},
//   {path: "/edit-inward-stock", component: EditStockInword},
//   {path: "/view-inward-stock", component: ViewStockInword},
//   {path: "/outward-stock-list", component: OutwordStockList},
//   {path: "/edit-outward-stock", component: EditStockOutword},
//   {path: "/view-outward-stock", component: ViewStockOutword},
//   {path: "/delivery-challan", component: DeliveryChallan},

//   //sales office
//   {path: "/user-dashboard", component: UserDashboard},
//   {path: "/user-edit-inward-stock", component: UserEditInwardStock},
//   {path: "/user-view-inward-stock", component: UserViewInwardStock},
//   {path: "/user-edit-outward-stock", component: UserEditOutwardStock},
//   {path: "/user-view-outward-stock", component: UserViewOutwardStock},
//   {path: "/user-add-stock-inward", component: UserAddStockInward},
//   {path: "/user-outward-stock", component: UserOutwardStock},
//   {path: "/user-office-stock-list", component: UserOfficeStockList},
//   {path: "/user-outward-stock-list", component: UserOutwardStockList},
//   // {path: "/sales-user-profile", component: SalesUserProfile},
//   // {path: "/update-password", component: UserUpdatePassword},

//   // data entry factory office
//   {path: "/data-entry-dashboard", component: DataEntryDashboard},
//   {path: "/data-entry-add-stock-inward", component: DataEntryAddStockInward},
//   {path: "/data-entry-add-stock-outward", component: DataEntryAddStockOutward},
//   {path: "/data-entry-outward-stock", component: DataEntryOutwardStock},
//   {path: "/data-entry-office-stock-list", component: DataEntryOfficeStockList},
//   {path: "/data-entry-edit-inward-stock", component: DataEntryEditStockInward},
//   {path: "/data-entry-view-inward-stock", component: DataEntryViewStockInward},
//   {path: "/data-entry-outward-stock-list", component: DataEntryOutwardStockList},
//   {path: "/data-entry-edit-outward-stock", component: DataEntryEditOutwardStock},
//   {path: "/data-entry-view-outward-stock", component: DataEntryViewOutwardStok},
//   {path: "/data-entry-user-profile", component: DataEntryUserProfile},
//   // {path: "/user-profile", component: DataEntry},

//   // Grader Flow
//   {path: "/grader-dashboard", component: GraderDashboard},
//   {path: "/grader-edit-verify-accept", component: EditverifyAndAccept},
//   {path: "/grader-view-verify-accept", component: ViewVerifyAndAccept},
//   {path: "/grader-stock-list", component: GraderStockList},
//   {path: "/assign-stock-list", component: AssignStockList},
//   {path: "/grader-assign-screen", component: GraderAssignScreen},
//   {path: "/grader-assign-screen2", component : GraderAssignScreen2},
//   {path: "/grader-profile", component: GraderProfile},
//   {path: "/user-profile", component: GraderUpdatePassword},
//   {path: "/grader-process-stock-accept-reject", component: ProcessStockAcceptAndReject},
//   {path: "/grader-processed-stock-list", component: GraderProcessedStock},
//   {path: "/cycle1-verify-accept", component: Cycle1VerifyAndAccept},
//   {path: "/grader-reassign", component: GraderReassign},
//   {path: "/accepted-process-stock", component: ProcessStockAccepted},
//   {path: "/client-reject-stock", component: ClientRejectStock},

//   // filler Flow
//   {path: "/filler-dashboard", component: FillerDashboard},
//   {path: "/filler-edit-verify-accept", component: FillerEditVerifyAndAccept},
//   {path: "/filler-view-verify-accept", component: FillerViewVerifyAndAccept},
//   {path: "/filler-stock-list", component: FillerStockList},
//   {path: "/cube-list", component: CubeList},
//   {path: "/filler-process-list", component: FillerProcessList},
//   {path: "/filler-assign-cube", component: FillerAssignCube},
//   {path: "/filler-assign-cube-detail", component: FillerAssignCubeDetail},
//   {path: "/filler-edit-filling-process", component: EditFillingProcess},
//   // {path: "/filler-profile", component: FillerProfle},
//   // {path: "/user-profile", component: FillerUpdatePassword},

//   // machine operator Flow
//   {path: "/machine-operator-dashboard", component: MachineOperatorDashboard},
//   {path: "/machine-operator-edit-verify-accept", component: MacOperatorEditVerifyAndAccept},
//   {path: "/machine-operator-view-verify-accept", component: MacOperatorViewVerifyAndAccept},
//   {path: "/machine-operator-cube-list", component: MacOperatorCubeList},
//   {path: "/assign-cube-list", component: AssignCubeStockList},
//   {path: "/machine-operator-assign-cube", component: MacOperatorAssignCube},
//   {path: "/machine-operator-user-profile", component: MacOperatorUserProfile},
//   {path: "/user-profile", component: MacOperatorUpdatePassword},

//   // admin reports
//   {path: "/party-wise-reports", component: PartyWiseReports},
//   {path: "/generate-ledger", component: GenerateLedger},
//   {path: "/ledger-report", component: LedgerReports},
//   {path: "/print-ledger-report", component: PrintLedgerReport},
//   {path: "/view-ledger-report", component: ViewledgerReport},
//   {path: "/ledger-print", component: LedgerPrint},
//   {path: "/active-person-stock", component: ActivePersonStock},
//   {path: "/party-wise-stock-report", component: PartyWiseStockReport},

//   // External unit
//   {path: "/external-generate-ledger", component: ExternalGenerateLedger},
//   {path: "/external-ledger-report", component: ExternalLedgerReport},
//   {path: "/external-print-ledger-report", component: ExternalPrintLedgerReport},
//   {path: "/external-view-ledger-report", component: ExternalViewLedgerReport},
//   {path: "/external-ledger-print", component: ExternalLedgerPrint},

//   // Transaction History
//   {path: "/transaction-list", component: TransactionList},
//   {path: "/edit-transaction-detail", component: EditTransactionDetail},
//   {path: "/view-transaction-detail", component: ViewTransactionHistory},
//   {path: "/tax-invoice", component: TaxInvoice},
//   {path: "/payment-cash", component: PaymentCash},
//   {path: "/payment-cheque", component: PaymentCheque},
//   {path: "/payment-rtgs", component: PaymentRTGS},

//   // Ui
//   { path: "/ui-alerts", component: UiAlert },
//   { path: "/ui-buttons", component: UiButtons },
//   { path: "/ui-cards", component: UiCards },
//   { path: "/ui-carousel", component: UiCarousel },
//   { path: "/ui-colors", component: UiColors },
//   { path: "/ui-dropdowns", component: UiDropdown },
//   { path: "/ui-general", component: UiGeneral },
//   { path: "/ui-grid", component: UiGrid },
//   { path: "/ui-images", component: UiImages },
//   { path: "/ui-lightbox", component: UiLightbox },
//   { path: "/ui-modals", component: UiModal },
//   { path: "/ui-progressbars", component: UiProgressbar },
//   { path: "/ui-tabs-accordions", component: UiTabsAccordions },
//   { path: "/ui-typography", component: UiTypography },
//   { path: "/ui-video", component: UiVideo },
//   { path: "/ui-session-timeout", component: UiSessionTimeout },
//   { path: "/ui-rating", component: UiRating },
//   { path: "/ui-rangeslider", component: UiRangeSlider },
//   { path: "/ui-notifications", component: UiNotifications },
//   { path: "/ui-toasts", component: UiToast },
//   { path: "/ui-offcanvas", component: UiOffCanvas },
//   { path: "/ui-breadcrumb", component: Breadcrumb },
//   { path: "/ui-placeholders", component: UiPlaceholders },
//   //Utility
//   { path: "/pages-starter", component: PagesStarter },
//   { path: "/pages-timeline", component: PagesTimeline },
//   { path: "/pages-faqs", component: PagesFaqs },
//   { path: "/pages-pricing", component: PagesPricing },

//   // this route should be at the end of all other routes
//   // eslint-disable-next-line react/display-name
//   { path: "/", exact: true, component: () => <Redirect to="/login" /> },
// ];
const mainAuth = [

  {
    path: "/admin-dashboard",
    component: Dashboard,
    roleId: "ROLE0000000",
  },
  {
    path: "/generate-Ledger",
    component: GenerateLedger,
    roleId: "ROLE0000000",
  },
  {
    path: "/party-wise-report",
    component: PartyWiseReports,
    roleId: "ROLE0000000",
  },
  {
    path: "/party-wise-jangad",
    component: PartyWiseJangad,
    roleId: "ROLE0000000",
  },
  {
    path: "/external-ledger-report",
    component: ExternalLedgerReport,
    roleId: "ROLE0000000",
  },
  {
    path: "/external-generate-ledger",
    component: ExternalGenerateLedger,
    roleId: "ROLE0000000",
  },
  {
    path: "/external-print-ledger-report",
    component: ExternalPrintLedgerReport,
    roleId: "ROLE0000000",
  },
  {
    path: "/factory-wise-report",
    component: FactoryWiseReport,
    roleId: "ROLE0000000",
  },
  {
    path: "/external-view-ledger-report",
    component: ExternalViewLedgerReport,
    roleId: "ROLE0000000",
  },
  {
    path: "/external-ledger-print",
    component: ExternalLedgerPrint,
    roleId: "ROLE0000000",
  },
  {
    path: "/ledger-report",
    component: LedgerReports,
    roleId: "ROLE0000000",
  },
  {
    path: "/print-ledger-report",
    component: PrintLedgerReport,
    roleId: "ROLE0000000",
  },
  {
    path: "/view-ledger-report",
    component: ViewledgerReport,
    roleId: "ROLE0000000",
  },
  {
    path: "/ledger-print",
    component: LedgerPrint,
    roleId: "ROLE0000000",
  },
  {
    path: "/active-person-stock",
    component: ActivePersonStock,
    roleId: "ROLE0000000",
  },
  {
    path: "/party-wise-stock-report",
    component: PartyWiseReports,
    roleId: "ROLE0000000",
  },
  {
    path: "/party-wise-stock-view",
    component: PartyWiseStockReport,
    roleId: "ROLE0000000",
  },
  {
    path: "/dashboard-saas",
    component: DashboardSaas,
    roleId: "ROLE0000000",
  },
  {
    path: "/dashboard-crypto",
    component: DashboardCrypto,
    roleId: "ROLE0000000",
  },
  {
    path: "/dashboard-blog",
    component: DashboardBlog,
    roleId: "ROLE0000000",
  },
  {
    path: "/crypto-wallet",
    component: CryptoWallet,
    roleId: "ROLE0000000",
  },
  {
    path: "/crypto-buy-sell",
    component: CryptoBuySell,
    roleId: "ROLE0000000",
  },
  {
    path: "/crypto-exchange",
    component: CryptoExchange,
    roleId: "ROLE0000000",
  },
  {
    path: "/crypto-lending",
    component: CryptoLending,
    roleId: "ROLE0000000",
  },
  {
    path: "/crypto-orders",
    component: CryptoOrders,
    roleId: "ROLE0000000",
  },
  {
    path: "/crypto-kyc-application",
    component: CryptoKYCApplication,
    roleId: "ROLE0000000",
  },
  { path: "/profile", component: UserProfile, roleId: "ROLE0000007" },
  { path: "/profile", component: UserProfile, roleId: "ROLE0000001" },
  { path: "/profile", component: UserProfile, roleId: "ROLE0000002" },
  { path: "/profile", component: UserProfile, roleId: "ROLE0000003" },
  { path: "/profile", component: UserProfile, roleId: "ROLE0000004" },
  {
    path: "/update-password",
    component: UserPassword,
    roleId: "ROLE0000007",
  },
  {
    path: "/update-password",
    component: UserPassword,
    roleId: "ROLE0000002",
  },
  { path: "/add-party", component: AddParty, roleId: "ROLE0000000" },
  { path: "/party-list", component: PartyList, roleId: "ROLE0000000" },
  { path: "/add-party", component: AddParty, roleId: "ROLE0000007" },
  { path: "/party-list", component: PartyList, roleId: "ROLE0000007" },
  {
    path: "/organization-detail",
    component: OrganizationDetail,
    roleId: "ROLE0000000",
  },
  {
    path: "/office-stock-list",
    roleId: "ROLE0000000",
    component: OfficeStockList,
  },
  {
    path: "/delivery-challan",
    roleId: "ROLE0000000",
    component: DeliveryChallan,
  },
  { path: "/gst-rate", component: GstRate, roleId: "ROLE0000000" },
  { path: "/add-unit", component: AddUnit, roleId: "ROLE0000000" },
  {
    path: "/organization-partyList",
    component: OrganizationCompanyList,
    roleId: "ROLE0000000",
  },
  {
    path: "/add-material-item",
    component: AddMaterialItem,
    roleId: "ROLE0000000",
  },
  {
    path: "/add-purchased-item",
    component: AddPurchasedItem,
    roleId: "ROLE0000000",
  },
  {
    path: "/add-purchased-item",
    component: AddPurchasedItem,
    roleId: "ROLE0000007",
  },
  {
    path: "/add-purchased-item",
    component: AddPurchasedItem,
    roleId: "ROLE0000008",
  },
  {
    path: "/allocate-material",
    component: AllocateMaterial,
    roleId: "ROLE0000000",
  },
  {
    path: "/allocate-material",
    component: AllocateMaterial,
    roleId: "ROLE0000007",
  },
  {
    path: "/allocate-material",
    component: AllocateMaterial,
    roleId: "ROLE0000008",
  },
  {
    path: "/allocate-material-list",
    component: AllocateMaterialList,
    roleId: "ROLE0000000",
  },
  {
    path: "/allocate-material-list",
    component: AllocateMaterialList,
    roleId: "ROLE0000007",
  },
  {
    path: "/allocate-material-list",
    component: AllocateMaterialList,
    roleId: "ROLE0000008",
  },
  {
    path: "/party-material-stock",
    component: CompanyMaterialStock,
    roleId: "ROLE0000000",
  },
  {
    path: "/party-material-stock",
    component: CompanyMaterialStock,
    roleId: "ROLE0000007",
  },
  {
    path: "/party-material-stock",
    component: CompanyMaterialStock,
    roleId: "ROLE0000008",
  },
  {
    path: "/organization-shape",
    component: Shape,
    roleId: "ROLE0000000",
  },
  {
    path: "/organization-process",
    component: Processes,
    roleId: "ROLE0000000",
  },
  {
    path: "/organization-items",
    component: Items,
    roleId: "ROLE0000000",
  },
  {
    path: "/organization-items",
    component: Items,
    roleId: "ROLE0000007",
  },
  {
    path: "/organization-items",
    component: Items,
    roleId: "ROLE0000008",
  },
  {
    path: "/organization-category",
    component: Category,
    roleId: "ROLE0000000",
  },
  {
    path: "/organization-inclusion",
    component: Inclusion,
    roleId: "ROLE0000000",
  },
  { path: "/add-user", component: AddUser, roleId: "ROLE0000000" },
  { path: "/user-list", component: UserList, roleId: "ROLE0000000" },
  {
    path: "/internal-unit-inward",
    component: InternalUnitinward,
    roleId: "ROLE0000000",
  },
  {
    path: "/outward-stock-list",
    component: OutwordStockList,
    roleId: "ROLE0000000",
  },
  {
    path: "/view-jangad-timeline-manage-stock",
    component: ViewJangadTimelineManageStock,
    roleId: "ROLE0000000",
  },
  {
    path: "/user-dashboard",
    component: UserDashboard,
    roleId: "ROLE0000007",
  },
  {
    path: "/user-add-stock-inward",
    component: UserAddStockInward,
    roleId: "ROLE0000007",
  },
  {
    path: "/reassign-stock-inward",
    component: ReassignInwardJangad,
    roleId: "ROLE0000007",
  },
  {
    path: "/receive-external-jangad",
    component: RecieveExternalJangad,
    roleId: "ROLE0000007",
  },
  {
    path: "/user-outward-stock",
    component: UserOutwardStock,
    roleId: "ROLE0000007",
  },
  {
    path: "/user-office-stock-list",
    component: UserOfficeStockList,
    roleId: "ROLE0000007",
  },
  {
    path: "/user-outward-stock-list",
    component: UserOutwardStockList,
    roleId: "ROLE0000007",
  },
  {
    path: "/rejected-diamond",
    component: RejectedDiamond,
    roleId: "ROLE0000007",
  },
  {
    path: "/data-entry-dashboard",
    component: DataEntryDashboard,
    roleId: "ROLE0000001",
  },
  {
    path: "/data-entry-outward-stock",
    component: DataEntryOutwardStock,
    roleId: "ROLE0000001",
  },
  {
    path: "/data-entry-add-stock-inward",
    component: DataEntryAddStockInward,
    roleId: "ROLE0000001",
  },
  {
    path: "/data-entry-accept-express-inward",
    component: AcceptExpressInward,
    roleId: "ROLE0000001",
  },
  {
    path: "/data-entry-express-inward-list",
    component: DataEntryExpressInwardList,
    roleId: "ROLE0000001",
  },
  
  {
    path: "/data-entry-express-dashboard",
    component: DataEntryExpressDashboard,
    roleId: "ROLE0000001",
  },
  {
    path: "/data-entry-office-stock-list",
    component: DataEntryOfficeStockList,
    roleId: "ROLE0000001",
  },
  {
    path: "/rejected-diamond-grader",
    component: RejectedDiamondGrader,
    roleId: "ROLE0000001",
  },
  {
    path: "/data-entry-outward-stock-list",
    component: DataEntryOutwardStockList,
    roleId: "ROLE0000001",
  },
  {
    path: "/grader-dashboard",
    component: GraderDashboard,
    roleId: "ROLE0000002",
  },
  {
    path: "/grader-dataentry-assign",
    component: GraderDataEntryAssign,
    roleId: "ROLE0000002",
  },
  {
    path: "/grader-stock-list",
    component: GraderStockList,
    roleId: "ROLE0000002",
  },
  {
    path: "/grader-edit-verify-accept",
    component: EditverifyAndAccept,
    roleId: "ROLE0000002",
  },
  {
    path: "/grader-complete-stock-list",
    component: GraderCompleteStockList,
    roleId: "ROLE0000002",
  },
  {
    path: "/assign-stock-list",
    component: AssignStockList,
    roleId: "ROLE0000002",
  },
  {
    path: "/grader-assign-screen",
    component: GraderAssignScreen,
    roleId: "ROLE0000002",
  },
  {
    path: "/grader-assign-screen2",
    component: GraderAssignScreen2,
    roleId: "ROLE0000002",
  },
  {
    path: "/user-profile",
    component: GraderUpdatePassword,
    roleId: "ROLE0000003",
  },
  {
    path: "/user-profile",
    component: GraderUpdatePassword,
    roleId: "ROLE0000004",
  },
  {
    path: "/grader-processed-stock-list",
    component: GraderProcessedStock,
    roleId: "ROLE0000002",
  },
  {
    path: "/grader-repeat-stock-list",
    component: GraderRepeatStockList,
    roleId: "ROLE0000002",
  },
  {
    path: "/grader-process-stock-accept-reject",
    component: ProcessStockAcceptAndReject,
    roleId: "ROLE0000002",
  },
  {
    path: "/grader-reassign",
    component: GraderReassign,
    roleId: "ROLE0000002",
  },
  {
    path: "/view-jangad-timeline",
    component: ViewJangadTImeline,
    roleId: "ROLE0000002",
  },
  {
    path: "/accepted-process-stock",
    component: ProcessStockAccepted,
    roleId: "ROLE0000002",
  },
  {
    path: "/client-reject-stock",
    component: ClientRejectStock,
    roleId: "ROLE0000002",
  },
  {
    path: "/cycle1-verify-accept",
    component: Cycle1VerifyAndAccept,
    roleId: "ROLE0000002",
  },
  {
    path: "/filler-dashboard",
    component: FillerDashboard,
    roleId: "ROLE0000003",
  },
  {
    path: "/filler-stock-list",
    component: FillerStockList,
    roleId: "ROLE0000003",
  },
  {
    path: "/filler-repeat-stock-list",
    component: FillerRepeatStock,
    roleId: "ROLE0000003",
  },
  { path: "/cube-list", component: CubeList, roleId: "ROLE0000003" },
  {
    path: "/filler-edit-filling-process",
    component: EditFillingProcess,
    roleId: "ROLE0000003",
  },
  {
    path: "/filler-edit-verify-accept",
    component: FillerEditVerifyAndAccept,
    roleId: "ROLE0000003",
  },
  {
    path: "/machine-operator-dashboard",
    component: MachineOperatorDashboard,
    roleId: "ROLE0000004",
  },
  {
    path: "/machine-operator-stock-summary",
    component: StockSummary,
    roleId: "ROLE0000004",
  },
  {
    path: "/machine-operator-summary-show",
    component: SummaryShow,
    roleId: "ROLE0000004",
  },
  {
    path: "/machine-operator-edit-verify-accept",
    component: MacOperatorEditVerifyAndAccept,
    roleId: "ROLE0000004",
  },
  {
    path: "/machine-operator-cube-list",
    component: MacOperatorCubeList,
    roleId: "ROLE0000004",
  },
  {
    path: "/assign-cube-list",
    component: AssignCubeStockList,
    roleId: "ROLE0000004",
  },
  {
    path: "/user-profile",
    component: MacOperatorUpdatePassword,
    roleId: "ROLE0000003",
  },
  {
    path: "/user-profile",
    component: MacOperatorUpdatePassword,
    roleId: "ROLE0000004",
  },
  {
    path: "/transaction-list",
    component: TransactionList,
    roleId: "ROLE0000000",
  },
  {
    path: "/approve-status-update",
    component: LedgerApproveStatusUpdate,
    roleId: "ROLE0000000",
  },
  {
    path: "/bank",
    component: AddBank,
    roleId: "ROLE0000000",
  },
  {
    path: "/edit-transaction-detail",
    component: EditTransactionDetail,
    roleId: "ROLE0000000",
  },
  {
    path: "/view-transaction-detail",
    component: ViewTransactionHistory,
    roleId: "ROLE0000000",
  },
  {
    path: "/tax-invoice",
    component: TaxInvoice,
    roleId: "ROLE0000000",
  },
  {
    path: "/payment-cash",
    component: PaymentCash,
    roleId: "ROLE0000000",
  },
  {
    path: "/payment-cheque",
    component: PaymentCheque,
    roleId: "ROLE0000000",
  },
  {
    path: "/payment-rtgs",
    component: PaymentRTGS,
    roleId: "ROLE0000000",
  },
  {
    path: "/user-add-express-inward",
    component: AddExpressInward,
    roleId: "ROLE0000007",
  },
  {
    path: "/user-express-inward-list",
    component: ExpressInwardList,
    roleId: "ROLE0000007",
  },
  {
    path: "/express-dashboard",
    component: ExpressDashboard,
    roleId: "ROLE0000007",
  },
  {
    path: "/view-express-inward",
    component: ViewExpressInward,
    roleId: "ROLE0000001",
  },
  {
    path: "/sales-view-express-inward",
    component: ExpressViewInward,
    roleId: "ROLE0000007",
  },
  { path: "/404",  exact: true,component: Default404 },
];
var authProtectedRoutes;

const userData = JSON.parse(localStorage.getItem("authUser"));
if (userData && userData.id) {
  var authProtectedRoutes = mainAuth.filter(
    x => { 
      return  x.roleId == userData.roleId || userData.id.includes("ADMIN") ? "ROLE0000000" : ""}
  );
} else {
  localStorage.removeItem("authUser")
  authProtectedRoutes = [];
}
const publicRoutes = [

  { path: "/logout", component: Logout },
  { path: "/login", component: Login1 },
  { path: "/forgot-password", component: ForgetPwd },
  { path: "/register", component: Register },

  { path: "/pages-maintenance", component: PagesMaintenance },
  { path: "/pages-comingsoon", component: PagesComingsoon },
  { path: "/pages-404", component: Pages404 },
  { path: "/pages-500", component: Pages500 },
  { path: "/crypto-ico-landing", component: CryptoIcoLanding },

  // Authentication Inner
  { path: "/pages-login", component: Login1 },
  { path: "/pages-login-2", component: Login2 },

  { path: "/pages-register", component: Register1 },
  { path: "/pages-register-2", component: Register2 },

  { path: "/page-recoverpw", component: Recoverpw },
  { path: "/pages-recoverpw-2", component: Recoverpw2 },

  { path: "/pages-forgot-pwd", component: ForgetPwd1 },
  { path: "/pages-forgot-pwd-2", component: ForgetPwd2 },

  { path: "/newpass", component: NewPassword },

  { path: "/auth-lock-screen", component: LockScreen },
  { path: "/auth-lock-screen-2", component: LockScreen2 },
  { path: "/page-confirm-mail", component: ConfirmMail },
  { path: "/page-confirm-mail-2", component: ConfirmMail2 },
  { path: "/auth-email-verification", component: EmailVerification },
  { path: "/auth-email-verification-2", component: EmailVerification2 },
  { path: "/auth-two-step-verification", component: TwostepVerification },
  { path: "/auth-two-step-verification-2", component: TwostepVerification2 },
  { path: "/404",  exact: true,component: Default404 },
  // { path: "/", exact: true, component: () => switchRoutes() },
];

export { authProtectedRoutes, publicRoutes };
